// Librerías
import React, { useState, useEffect } from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import '../../../assets/styles/PropertyPage/Utils/_gallery.sass';

const PropertyGallery = ({ images, video }) => {
  const [showGallery, setShowGallery] = useState(false);
  const [startIndex, setStartIndex] = useState(0);

  // Preparar imágenes para react-image-gallery
  const galleryImages = [
    {
      original: video.media,
      thumbnail: video.media,
      description: video.description || 'Video de la propiedad'
    },
    ...images.map(img => ({
      original: img.media,
      thumbnail: img.media,
      description: img.description || 'Imagen de la propiedad'
    }))
  ];

  const openGallery = (index) => {
    setStartIndex(index);
    setShowGallery(true);
  };

  const closeGallery = () => {
    setShowGallery(false);
  };

  // Cerrar galería con tecla ESC
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        closeGallery();
      }
    };

    if (showGallery) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden'; // Prevenir scroll
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [showGallery]);

  const listImages = images.map((item, index) => {
    return (
      <div 
        className="PropertyGallery__imgContainer__images__imgc" 
        key={item.id}
        onClick={() => openGallery(index + 1)} // +1 porque video está en posición 0
        style={{ cursor: 'pointer' }}
        title="Clic para ver en grande"
      >
        <img src={item.media} alt={item.description || 'Imagen de la propiedad'} />
        {/* Overlay opcional para indicar que es clickeable */}
        <div className="image-overlay">
          <span>🔍</span>
        </div>
      </div>
    );
  });

  return(
    <React.Fragment>
      <div className="PropertyGallery">
        <div className="PropertyGallery__imgContainer">
          <div 
            className="PropertyGallery__imgContainer__video"
            onClick={() => openGallery(0)}
            style={{ cursor: 'pointer' }}
            title="Clic para ver en grande"
          >
            <img src={video.media} alt={video.description || 'Video de la propiedad'}/>
            <div className="image-overlay">
              <span>🔍</span>
            </div>
          </div>
          <div className="PropertyGallery__imgContainer__images">
            { listImages }
          </div>
        </div>
      </div>

      {showGallery && (
        <div className="gallery-modal" onClick={closeGallery}>
          <div className="gallery-container" onClick={(e) => e.stopPropagation()}>
            <button 
              className="close-gallery" 
              onClick={closeGallery}
              title="Cerrar galería (ESC)"
            >
              ×
            </button>
            <ImageGallery
              items={galleryImages}
              startIndex={startIndex}
              showThumbnails={true}
              showFullscreenButton={true}
              showPlayButton={false}
              showBullets={false}
              showNav={true}
              slideOnThumbnailOver={false}
              additionalClass="custom-gallery"
            />
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default PropertyGallery;